module.exports = __webpack_public_path__ + "img/ok.208cf3cd.png";